import { render, staticRenderFns } from "./addReturnCode.vue?vue&type=template&id=77c34a78&scoped=true"
import script from "./addReturnCode.vue?vue&type=script&lang=js"
export * from "./addReturnCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c34a78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77c34a78')) {
      api.createRecord('77c34a78', component.options)
    } else {
      api.reload('77c34a78', component.options)
    }
    module.hot.accept("./addReturnCode.vue?vue&type=template&id=77c34a78&scoped=true", function () {
      api.rerender('77c34a78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operatingPlatform/returnCodePrinting/component/addReturnCode.vue"
export default component.exports